var _ellipse, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStep1 = function SvgStep1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.5714,
    rx: 12,
    ry: 11.4286,
    fill: "#0A446D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9744 16.3536C8.9744 16.1296 9.0864 16.0176 9.3104 16.0176H11.4776V8.8104L10.0328 10.1712C9.9544 10.2496 9.876 10.2888 9.7976 10.2888C9.7192 10.2888 9.6576 10.2552 9.6128 10.188L8.7056 9.0288C8.6384 8.9504 8.6048 8.8776 8.6048 8.8104C8.6048 8.732 8.6496 8.6536 8.7392 8.5752L11.0912 6.4584C11.1808 6.38 11.2592 6.324 11.3264 6.2904C11.3936 6.2568 11.5056 6.24 11.6624 6.24H13.3256C13.5496 6.24 13.6616 6.352 13.6616 6.576V16.0176H15.8288C16.0528 16.0176 16.1648 16.1296 16.1648 16.3536V17.664C16.1648 17.888 16.0528 18 15.8288 18H9.3104C9.0864 18 8.9744 17.888 8.9744 17.664V16.3536Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step1.762098a3.svg";
export { ForwardRef as ReactComponent };